import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

import Button from "../../../../../components/elements/Button";

import { createEmptyProjectStep } from "../shared/factories";
import StepEditorCard from "./StepEditorCard";

export default function StepsEditor({
                                        project,
                                        steps,
                                        path,
                                        updateAtPath
                                    }) {

    const canDeleteStep = () => steps.length > 1;

    const addStep = () => {

        updateAtPath(
            path,
            [
                ...steps,
                createEmptyProjectStep(project.workspace.template)
            ]
        );

    };

    const deleteStep = (stepIndex) => {

        if (!canDeleteStep()) {
            window.alert("You must have at least one step.");
            return;
        }

        updateAtPath(
            path,
            steps.filter((_, i) => i !== stepIndex)
        );

    };

    return (

        <div className="grid gap-10 mb-16">

            <div className="flex items-center gap-3">

                <h3>Steps</h3>

                <Button onClick={addStep}>
                    <FontAwesomeIcon icon={faPlus} />
                </Button>

            </div>

            {

                steps.map((step, index) => (

                    <StepEditorCard
                        key={step.id || index}
                        project={project}
                        step={step}
                        path={[...path, index]}
                        updateAtPath={updateAtPath}
                        canDelete={canDeleteStep()}
                        onDelete={() => deleteStep(index)}
                    />

                ))

            }

        </div>

    );

}